import React from "react";

export default function ResponsiveImage({ src, mobileSrc, alt = "", ...rest }) {
  return (
    <picture>
      {mobileSrc && <source media="(max-width: 768px)" srcSet={mobileSrc} />}
      <img src={src} alt={alt} {...rest} loading="lazy" />
    </picture>
  );
}
